import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowUpRight } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon.jsx';

export default function FinalMessage() {
  return (
    <section className="relative min-h-[80vh] bg-gradient-to-b from-[#052340] to-black text-white flex flex-col items-center justify-center px-6 py-24 text-center overflow-hidden">
      <motion.div 
        initial={{ opacity: 0, y: 40 }} 
        whileInView={{ opacity: 1, y: 0 }} 
        viewport={{ once: true, margin: "-100px" }} 
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }} 
        className="max-w-4xl mx-auto z-10 flex flex-col items-center"
      >
        <h2 className="text-3xl md:text-5xl lg:text-7xl font-serif mb-8 text-balance leading-tight">
          Supporting Life <span className="italic text-[#25a7df]">at Every Stage</span>
        </h2>
        
        <p className="text-lg md:text-xl text-white/70 font-light max-w-2xl mx-auto leading-relaxed mb-12">
          We serve communities through healthcare, education, innovation, and sustainable growth - creating lasting impact for individuals and families.
        </p>

        <p className="text-xl md:text-2xl font-medium tracking-wide">
          More than healthcare. <br className="md:hidden" /> <span className="text-[#25a7df]">It's a lifestyle.</span>
        </p>

        <motion.a 
          href="https://healthcare.svcaregroup.com"
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.05 }} 
          whileTap={{ scale: 0.95 }} 
          className="mt-16 group flex items-center gap-3 px-8 py-4 rounded-full border border-white/20 hover:bg-white hover:text-brand-dark transition-colors duration-300"
        >
          <span className="text-sm tracking-widest uppercase font-medium">Discover More</span>
          <SafeIcon icon={FiArrowUpRight} className="text-lg transition-transform group-hover:rotate-45" />
        </motion.a>
      </motion.div>

      {/* Footer minimal links */}
      <div className="absolute bottom-8 w-full px-8 flex justify-center items-center text-xs text-white/40 uppercase tracking-widest">
        <span>© 2026. All Rights Reserved SV Care Group</span>
      </div>
    </section>
  );
}